import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useLocalization } from '~/composables/_next/useLocalization';
import { useSegment } from '~/composables/_next/useSegment';
import { cacheControl } from '~/helpers/cacheControl';

// Fixes an invalid chunk name in the build process. Should be removed when we move to vite.
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
const __nuxt_page_meta = {
  middleware: [cacheControl('public, s-maxage=7200, stale-while-revalidate=3600, stale-if-error=3600'),
      // 2 hours cache and 1 hour stale
      defineNuxtRouteMiddleware(function (to) {
        var _useNuxt2App = useNuxt2App(),
          app = _useNuxt2App.app;
        var _useLocalization = useLocalization(),
          locale = _useLocalization.locale;
        if (locale === 'fr') {
          return app.localePath({
            name: 'product-slug',
            params: {
              slug: to.params.slug
            },
            query: {
              page: 'library'
            }
          });
        }
      })],tracking: {
        category: TrackingPageCategory.EODP
      }
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: '_slug',
  setup: function setup(__props) {
    var ProductDescriptionPage = function ProductDescriptionPage() {
      return import('~/pages/product/_slug.vue');
    };
    ;

    // TODO: Remove after Nuxt 3 migration
    onMounted(function () {
      var _useSegment = useSegment(),
        analytics = _useSegment.analytics;
      var route = useRoute();
      analytics.page(TrackingPageCategory.EODP, PageTypes.EODP, {
        path: route.fullPath
      });
    });
    return {
      __sfc: true,
      ProductDescriptionPage: ProductDescriptionPage
    };
  }
});